export default "__VITE_ASSET__CBtgnb0e__"